//ユーザ登録(Email)
import { BaseSyntheticEvent, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, SubmitHandler } from "react-hook-form";
import * as Yup from "yup";
import { passwordValidateion } from "../../common/Valitation";
import queryString from 'query-string';
import { HttpPostData, JumpPage } from '../../common/Util';
import { ResponseParamBase } from '../../common/Types';
import { yupResolver } from '@hookform/resolvers/yup';
import { OnsiteProgress, ErrorMessageComp } from "../../customelements/CustomInput";
import { LoginStateConext } from "../../context/AuthContext";
import { TitleParamContext } from '../../context/TitleContext';
import { ResponseParam as LoginResponseParam, LoginInputs } from "../../view/Login";
import { RegisterPageInfo } from '../../context/RegisterPageTypeContext';
import { PurchaseHistoryRow, PageParam } from "../../view/license/Paymentconfirm";
import market from "../../css/market.module.scss";
import base from "../../css/base.module.css";

export type RegistTrialUserParam = {
    mailtoken: string,
    p: string,
}

export type IFormInputs = {
    password: string,
}

type ResponseParam = ResponseParamBase & {
    registerpagetype: number,
    email: string,
}

type CheckResponseParam = ResponseParamBase & {
    email: string,
    list: PurchaseHistoryRow[]
}

const schema = Yup.object({
    password: passwordValidateion,
}).required();

export const CompleteTrialUser = () => {

    const { handleSubmit, control, formState: { errors, isValid } } = useForm<IFormInputs>({
        defaultValues: {
            password: ""
        },
        resolver: yupResolver(schema),
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const location = useLocation();
    const navigate = useNavigate();
    const pageParam = queryString.parse(location.search) as RegistTrialUserParam;
    const ctx = useContext(LoginStateConext);
    const titleConext = useContext(TitleParamContext);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isCheckLoading, setIsCheckLoading] = useState<boolean>(false);
    const [checkResult, setCheckResult] = useState<CheckResponseParam>({ resultFlg: false, message: "", email: "", list: [] });


    const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs, event?: BaseSyntheticEvent) => {
        /*setErrorMessage("");
        await HttpPostData<ResponseParam>("", {}, setIsCheckLoading)
            .then(async response => {
                if (response.data.resultFlg) {
                    await HttpPostData
                }
            })
        await HttpPostData<ResponseParam>("/userregister/emailregister", { ...pageParam, password: data.password }, setIsLoading)
            .then(async response => {
                if (response.status === 200) {
                    if (response.data.resultFlg) {
                        //ログインを行う
                        await HttpPostData<LoginResponseParam>("authenticate/login", { email: response.data.email, password: data.password } as LoginInputs, setIsLoading)
                            .then(loginResponse => {
                                if (loginResponse.data.resultFlg) {
                                    ctx.setIsLogin(true);
                                    ctx.setLoginInfo({ email: loginResponse.data.userdata.email, userName: loginResponse.data.userdata.userName });
                                    window.localStorage.setItem("clickeracejwttoken", loginResponse.data.jwtToken);
                                    if (response.data.registerpagetype === 1) {
                                        JumpPage("CompleteRegister", { registerPageType: response.data.registerpagetype } as RegisterPageInfo, "", navigate);
                                    } else if (response.data.registerpagetype === 2) {
                                        JumpPage("CompleteRegister", { registerPageType: response.data.registerpagetype } as RegisterPageInfo, "", navigate);
                                    } else {
                                        JumpPage("CompleteRegister", { registerPageType: response.data.registerpagetype } as RegisterPageInfo, "", navigate);
                                    }
                                }
                            })
                        //登録時のタイプによって遷移先に渡すパラメータを切り替える

                    } else {
                        setErrorMessage(response.data.message);
                    }
                }
            })
            .catch(e => {
                console.log(e);
            })*/
    }

    useEffect(() => {
        (async () => {
            titleConext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "サポート会員情報", secondSubTitle: "（パスワード確認）" });
            await HttpPostData<CheckResponseParam>("/userregister/registertrialuser", { mailtoken: pageParam.mailtoken, p: pageParam.p }, setIsCheckLoading)
                .then(async response => {
                    if (response.data.resultFlg) {
                        await HttpPostData<LoginResponseParam>("authenticate/login", { email: response.data.email, password: pageParam.p } as LoginInputs, setIsLoading)
                            .then(loginResponse => {
                                if (loginResponse.data.resultFlg) {
                                    ctx.setIsLogin(true);
                                    ctx.setLoginInfo({ email: loginResponse.data.userdata.email, userName: loginResponse.data.userdata.userName });
                                    window.localStorage.setItem("clickeracejwttoken", loginResponse.data.jwtToken);
                                    JumpPage<PageParam>("/completetrialuser", { list: response.data.list }, "", navigate);                                    
                                }
                            });
                    } else {
                        setErrorMessage(response.data.message);
                        setCheckResult(response.data);
                    }
                })
                .catch(e => {
                    setCheckResult({ resultFlg: false, message: "お試しライセンスの発行に失敗しました。", email: "", list: [] });
                });
        })()
    }, []);

    return (
        <>
            <form onSubmit={(e) => { handleSubmit(onSubmit)(e) }}>
                <section className={market.marketArea}>
                    <div className={market.marketAreaInner}>
                        {isCheckLoading ?
                            <div className={base.flexCenterColumn}><OnsiteProgress></OnsiteProgress></div>
                            :
                            checkResult.resultFlg ?
                                <>
                                    <ErrorMessageComp message={checkResult.message}></ErrorMessageComp>
                                </>
                                :
                                <>
                                    <ErrorMessageComp message={checkResult.message}></ErrorMessageComp>
                                </>
                        }
                    </div>
                </section>
            </form>
        </>
    );
}